import { Modal, Spinner } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import './styles.scss';

interface CreatingIntegrationModalProps {
    show: boolean;
    vendorName: string;
    imageUrl: string;
}

const CreatingIntegrationModal = ({ show, vendorName, imageUrl }: CreatingIntegrationModalProps) => (
    <Modal
        show={show}
        centered
        keyboard={false}
        backdrop="static"
        className="creating-integration"
        data-testid="creating-integration-modal"
    >
        <Modal.Body>
            <div className="d-flex flex-column align-items-center creating-integration__content">
                <div className="creating-integration__logo-wrapper">
                    <Spinner animation="border" className="creating-integration__ring" />
                    <img src={imageUrl} alt={vendorName} className="creating-integration__logo" />
                </div>
                <Typography variant="h4" color="text-high-emphasis">
                    Creating Integration
                </Typography>
                <Typography variant="body2" color="text-medium-emphasis">
                    Creating your {vendorName} connector...
                </Typography>
            </div>
        </Modal.Body>
    </Modal>
);

export default CreatingIntegrationModal;
